export default {
  getPackingListItem: (state) => state.packingListItem,
};
